import React, { Component } from "react";

export default class Impressum extends Component {
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  render() {
    return (
      <div className="container">
        <div className="padding-block-500">
          <div className="misc-heading">Impressum</div>
          <br />
          <div className="misc-paragraph">
            <h3 className="fw-bold">Angaben gemäß § 5 TMG:</h3>
            <p>Jens-Uwe Retter</p>
            <p>Gertraudenstraße 18, 10178 Berlin</p>
            <p>Tel.: 030 20619680</p>
            <p>Fax.: 030 2010232</p>
            <p>info@praxis-retter.de</p>
            <br />
            <h3 className="fw-bold">
              Inhaltlich verantwortlich gemäß § 55 RStV:
            </h3>
            <p>Jens-Uwe Retter</p>
            <br />
            <h3 className="fw-bold">Gesetzliche Berufsbezeichnung:</h3>
            <p>Arzt</p>
            <br />
            <h3 className="fw-bold">
              Staat, der die Berufsbezeichnung verliehen hat:
            </h3>
            <p>Bundesrepublik Deutschland</p>
            <br />
            <h3 className="fw-bold">Ärztekammer:</h3>
            <p>Ärztekammer Berlin</p>
            <p>Friedrichstr. 16</p>
            <p>10969 Berlin</p>
            <p>Tel.: +4930–40806-0</p>
            <p>E-Mail: kammer@aekb.de</p>
            <a
              href="www.aerztekammer-berlin.de"
              target="_blank"
              rel="noopener noreferrer">
              www.aerztekammer-berlin.de
            </a>
            <br />
            <br />
            <h3 className="fw-bold">Kassenärztliche Vereinigung:</h3>
            <p>Kassenärztliche Vereinigung Berlin</p>
            <p>Masurenallee 6 A</p>
            <p>14057 Berlin</p>
            <p>Tel.: +4930–310030</p>
            <a href="www.kvberlin.de" target="_blank" rel="noopener noreferrer">
              www.kvberlin.de
            </a>
            <br />
            <br />
            <h2 className="fw-bold">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr">
                https://ec.europa.eu/consumers/odr
              </a>
              .
            </p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <br />
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <br />
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet.
            </p>
            <br />
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
              wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
              werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </p>
          </div>
          <br />
          <div className="padding-block-700">
            <h3 className="fw-bold">Lizenzierte Bilder</h3>
            <p>©The Masterplan Std. / #346924203 – stock.adobe.com.</p>
            <p>©The Masterplan Std. / #346917136 – stock.adobe.com.</p>
            <p>©Craft Studio / #1700676666 – stock.adobe.com.</p>
          </div>
        </div>
      </div>
    );
  }
}
